import { ContestStatus } from '@betterpool/api-types/contests-service';

import { useContestContext } from '../../../../common/context/ContestContext/ContestContext';

import PlayerSurviorEntriesPageScheduled from './_entriesScheduled';
import PlayerSurviorEntriesPageNonScheduled from './_entriesNonScheduled';

function PlayerSurvivorEntriesOverallPage() {
  const { contest } = useContestContext();

  return contest.status === ContestStatus.SCHEDULED ? (
    <PlayerSurviorEntriesPageScheduled />
  ) : (
    <PlayerSurviorEntriesPageNonScheduled />
  );
}

export default PlayerSurvivorEntriesOverallPage;
